module.exports = __webpack_public_path__ + "static/img/transforma-tu-aventura-1.ce4b20f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/portfolio/xl/transforma-tu-aventura-1.jpg
// module id = 5Ars
// module chunks = 1